function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from "react";
import { take, throttleTime } from "rxjs/operators";
import { ExchangeID } from "TradeAPILib";
import ExchangeDataProvider from "../ExchangeDataProvider";
export function useTicker(base, quote, takeOnce) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    ticker = _useState2[0],
    setTicker = _useState2[1];
  // 仅使用一次
  var _useState3 = useState(takeOnce),
    _useState4 = _slicedToArray(_useState3, 1),
    takeOnceOpt = _useState4[0];
  var exchange = base && base.endsWith(".SWAP") ? ExchangeID.PIONEX_SWAP : ExchangeID.PIONEXV2;
  useEffect(function () {
    if (!base || !quote) {
      return;
    }
    var observable = ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservableByPair(exchange, base, quote);
    var takeOne = false;
    var customDuration;
    if (_typeof(takeOnceOpt) === "object") {
      takeOne = !!takeOnceOpt.once;
      customDuration = takeOnceOpt.duration;
    }
    if (takeOne) {
      observable = observable.pipe(take(1));
    } else if (customDuration) {
      observable = observable.pipe(throttleTime(customDuration, undefined, {
        leading: true
      }));
    }
    var subscription = observable.subscribe(function (data) {
      if (data && data.base === base && data.quote === quote) {
        setTicker(data);
      }
    }, function (error) {
      console.log(error);
    });
    return function () {
      return subscription && subscription.unsubscribe();
    };
  }, [base, quote, exchange, takeOnceOpt]);
  return ticker;
}
export function useTickerMap() {
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    tickerMap = _useState6[0],
    setTickerMap = _useState6[1];
  useEffect(function () {
    var subscription = ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservable(ExchangeID.PIONEXV2).subscribe(function (data) {
      setTickerMap(new Map(data));
    }, function (err) {});
    return function () {
      return subscription.unsubscribe();
    };
  }, []);
  return tickerMap;
}
export function useTickerMapActive(active) {
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    tickerMap = _useState8[0],
    setTickerMap = _useState8[1];
  useEffect(function () {
    if (!active) {
      return;
    }
    var subscription = ExchangeDataProvider.websocketManager.getTickerWebSocket().getTickerObservable(ExchangeID.PIONEXV2).subscribe(function (data) {
      setTickerMap(new Map(data));
    }, function (err) {});
    return function () {
      return subscription.unsubscribe();
    };
  }, [active]);
  return tickerMap;
}